import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function SupportCategoryList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "name", sortable: true, label: "Name" },
        { key: "actions" }
    ];
    const perPage = ref(10);
    const totalSupportCategoryList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const supportCategoriesMetaData = ref([]);
    const supportCategoryStatusOption = ref([]);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalSupportCategoryList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [
            currentPage,
            perPage,
            searchQuery,
            statusFilter,
        ],
        () => {
            refetchData();
        }
    );

    const fetchSupportCategoryList = (ctx, callback) => {
        store
            .dispatch("app-support-categories/fetchSupportCategories", {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
                status: statusFilter.value,
            })
            .then(response => {
                const support_category = response.data.data;
                const { total } = response.data.meta;
                supportCategoryStatusOption.value = response.data.status;

                callback(support_category);
                totalSupportCategoryList.value = total;
                supportCategoriesMetaData.value = support_category;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching support-categories",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching support-categories`,
                      icon:'ErrorIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                        },
                        {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                        })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == false) return "danger";
        if (status == true) return "success";
        return "primary";
    };

    return {
        fetchSupportCategoryList,
        tableColumns,
        perPage,
        currentPage,
        totalSupportCategoryList,
        supportCategoriesMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        resolveUserStatusVariant,
        supportCategoryStatusOption,
        statusFilter
    };
}
